module.exports = __webpack_public_path__ + "img/banner1.4d004a78.jpg";